// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"Body_bodyContainer__3WdDe"};